import {Slider, SliderProps} from "../Slider/Slider";
import {useMemo} from "react";
import {FormattedDateTime} from "../../date/FormattedDateTime/FormattedDateTime";

export type DateSliderProps = Omit<SliderProps, 'marks' | 'styles' | 'label'> & {
    dates: (Date | number)[]
}

export const DateSlider = (props: DateSliderProps) => {
    const {dates, ...rest} = props

    const marks = useMemo(() => {
        return dates.map((d, i) => {
            return {
                value: i,
                label: <FormattedDateTime date={d}/>
            }
        })
    }, [dates])

    return (
        <Slider
            {...rest}
            label={(val) => marks.find((mark) => mark.value === val)?.label}
            marks={marks}
            step={1}
            min={0}
            max={marks.length - 1}
            defaultValue={marks.length - 1}
            styles={{markLabel: {display: 'none'}}}
        />
    )
}
